import { render, staticRenderFns } from "./Concepts.vue?vue&type=template&id=1ba7b57e"
import script from "./Concepts.vue?vue&type=script&lang=js"
export * from "./Concepts.vue?vue&type=script&lang=js"
import style0 from "./Concepts.vue?vue&type=style&index=0&id=1ba7b57e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports